module.exports = __webpack_public_path__ + "static/media/check_trial.0d55551f.svg";